var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ReportGroupQuestions',{key:_vm.keyOfComponent})}
var staticRenderFns = []

export { render, staticRenderFns }